import { render, staticRenderFns } from "./YogaCheckbox.vue?vue&type=template&id=28956e8a&"
import script from "./YogaCheckbox.vue?vue&type=script&lang=js&"
export * from "./YogaCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./YogaCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "YogaCheckbox.vue"
export default component.exports